import { FaTachometerAlt } from "react-icons/fa";

export {
  SUPER_ADMIN_AUTH_PAGE_GROUP,
  SUPER_ADMIN_HOME_PAGE_GROUP,
  SUPER_ADMIN_MASTER_DATA_GROUP,
  SUPER_ADMIN_MASTER_DATA_GROUPS,
  SUPER_ADMIN_MASTER_DATA_ITEMS,
} from "./superAdminMasterDataRoutes";

export {
  SUPER_ADMIN_P2P_GROUP,
  SUPER_ADMIN_P2P_ITEMS,
} from "./superAdminP2pNavigation";

export {
  SUPER_ADMIN_CMS_GROUP,
  SUPER_ADMIN_CMS_ITEMS,
} from "./superAdminCmsNavigation";

export {
  SUPER_ADMIN_USER_MANAGEMENT_GROUP,
  SUPER_ADMIN_ROLE_MANAGEMENT_GROUP,
  SUPER_ADMIN_USER_MANAGEMENT_ITEMS,
  SUPER_ADMIN_ROLE_MANAGEMENT_ITEMS,
} from "./superAdminAccessNavigation";

export {
  SUPER_ADMIN_DISPUTE_MANAGEMENT_GROUP,
  SUPER_ADMIN_DISPUTE_MANAGEMENT_ITEMS,
} from "./superAdminDisputeNavigation";

export {
  SUPER_ADMIN_TICKET_MANAGEMENT_GROUP,
  SUPER_ADMIN_TICKET_MANAGEMENT_ITEMS,
} from "./superAdminTicketNavigation";

export {
  SUPER_ADMIN_FEEDBACK_MANAGEMENT_GROUP,
  SUPER_ADMIN_FEEDBACK_MANAGEMENT_ITEMS,
} from "./superAdminFeedbackNavigation";

export { SUPER_ADMIN_LOGISTICS_GROUP } from "./superAdminLogisticsNavigation";

export const SUPER_ADMIN_NAV_SECTIONS = [
  {
    id: "overview",
    title: "Overview",
    items: [
      {
        id: "sa-dashboard",
        label: "Dashboard",
        to: "/super-admin/dashboard",
        icon: FaTachometerAlt,
        end: true,
      },
    ],
  },
];

export const getSuperAdminNavIsActive = (pathname, item, search = "") => {
  if (!item?.to) return false;
  const [itemPath, itemQuery = ""] = item.to.split("?");
  const { activePathPrefix, activePathPrefixes } = item;

  if (itemQuery) {
    if (pathname !== itemPath) {
      return Boolean(activePathPrefix && pathname.startsWith(`${activePathPrefix}/`));
    }
    const expected = new URLSearchParams(itemQuery);
    const current = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    return [...expected.entries()].every(([key, value]) => current.get(key) === value);
  }

  if (activePathPrefixes?.length) {
    return activePathPrefixes.some(
      (p) => pathname === p || pathname.startsWith(`${p}/`),
    );
  }
  if (activePathPrefix) {
    return (
      pathname === item.to ||
      pathname.startsWith(`${item.to}/`) ||
      pathname.startsWith(`${activePathPrefix}/`) ||
      pathname === activePathPrefix
    );
  }
  if (item.end) {
    // Prefer exact list routes over query-filtered sibling links.
    if (pathname !== itemPath) return false;
    return !search || search === "?" || search === "";
  }
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
};
